module.exports = __webpack_public_path__ + "media/img/bg-2-42d797bb.jpg";